<script setup lang="ts">
const props = defineProps<{ error: any }>()

const { trackError } = useErrorTracking()

onMounted(() => {
  const statusCode: number = props.error?.statusCode ?? 0
  if (statusCode === 404) {
    trackError({ type: 'not_found', text: 'errors.page.notFound.title' })
  }
  else if (statusCode >= 500) {
    trackError({ type: 'server', text: 'errors.page.unknown.subtitle' })
  }
  else {
    trackError({ type: 'business', text: 'errors.page.unknown.subtitle' })
  }
})
</script>

<template>
  <NuxtLayout>
    <ErrorNotFound v-if="error.statusCode === 404" />
    <ErrorGeneral v-else :error="error" />
  </NuxtLayout>
</template>
